import FestiveOverlay from './FestiveOverlay';
import { useApp } from '../context/AppContext';

/**
 * Reads the festival admin has chosen and hands it to the overlay.
 *
 * Split from the overlay itself so the drawing has no idea where its
 * instructions came from, and can be dropped into a screenshot or a test
 * with a festival passed straight in.
 */
const FestiveLayer = () => {
  const { config } = useApp();
  const appearance = config?.appearance;
  if (!appearance) return null;
  return (
    <FestiveOverlay
      festival={appearance.festival}
      enabled={appearance.festiveEffects !== false}
    />
  );
};

export default FestiveLayer;
